enum ReportStatuses {
  Pending = 'pending',
  Generating = 'generating',
  Ready = 'ready',
  Failed = 'failed'
}

export default ReportStatuses;
